import * as React from "react";

const SvgIcnSideMenuOn = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M6 7a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V8a1 1 0 00-1-1H6zm0-1h12a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2z"
                fill="currentColor"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

export default SvgIcnSideMenuOn;
